/**
 * Knobs that were editor props on the prototype.
 */
export const config = {
  /**
   * Hero background clip. Empty falls back to the stock footage the prototype
   * shipped with — replace it with real site footage before the site goes live.
   * See CONTENT-TBC.md.
   */
  heroVideo: '',
  /** Stock fallback, highest rendition first. */
  heroVideoFallbacks: [
    'https://assets.mixkit.co/videos/31450/31450-720.mp4',
    'https://assets.mixkit.co/videos/31450/31450-360.mp4',
  ],
  /** The blue "currently on site" strip under the hero. */
  showTicker: true,
  /** Sector pre-selected on the projects page. */
  defaultSector: 'All',
  /** Home-page counter run-up, in milliseconds. */
  counterDuration: 1600,
  /** Viewport width below which the layout switches to its narrow arrangement. */
  narrowBreakpoint: 900,
  /**
   * Viewport width below which the header collapses to logo + Search + Menu.
   * Higher than `narrowBreakpoint` because the full nav, the search button and
   * the quote call to action need about 1050px to sit on one row — below that
   * the wide arrangement wraps to a double-height header.
   */
  navBreakpoint: 1080,
  /**
   * Viewport width below which the header shows the mark on its own. The
   * wordmark plus Search plus Menu need about 380px of row; under that they
   * overlap.
   */
  wordmarkBreakpoint: 400,
}
